import { m as motion } from "motion/react";
import { useAnimateFadeIn } from "../../../animation/animation";
import { TLink } from "../../../types";
import { PrimaryButtonLink } from "../../elements";
import styles from "./cta-block.module.less";

type TCTABlockProps = {
  title: string;
  text?: string;
  linkButton: TLink;
};

const CTABlock = ({ title, text, linkButton }: TCTABlockProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" });

  return (
    <motion.section {...fadeInAnimation} className={"max-width padded-sides centered space-mb-2xl"}>
      <div className={styles.backgroundWrapper}>
        <div className={[styles.contentWrapper, "text-max-width centered"].join(" ")}>
          <h3 className={styles.title}>{title}</h3>
          {text && <p className={`body-base`}>{text}</p>}
          {linkButton && (
            <PrimaryButtonLink
              url={linkButton?.url}
              label={linkButton?.title}
              onPreNavigate={linkButton.onPreNavigate}
            />
          )}
        </div>
      </div>
    </motion.section>
  );
};

export default CTABlock;
export { CTABlock };
